import styled from "styled-components";

interface MessageWrapperProps {
  variant?: "incoming" | "outgoing";
}

export const MessageWrapper = styled.div<MessageWrapperProps>`
  display: flex;
  gap: 6px;
  justify-content: ${(props) =>
    props.variant === "incoming" ? "flex-end" : "flex-start"};
`;
export const StyledOutgoingMessage = styled.div`
  display: flex;
  max-width: 80%;
  width: fit-content;
  padding: 15px;
  align-items: center;
  border-radius: 4px 18px 18px 18px;
  background-color: ${({ theme }) => theme.colors.bubble};
  font-feature-settings: "case" on;
  font-family: ${(props) => props.theme.typography.textsFont};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.0408px;
  margin-top: 20px;
  align-self: start;
  overflow-wrap: anywhere;
  p {
    width: 100%;
    margin: 0;
  }
`;
export const StyledIncomingMessage = styled.div`
  display: flex;
  max-width: 80%;
  width: fit-content;
  overflow-wrap: anywhere;
  padding: 15px;
  align-items: center;
  border-radius: 18px 18px 4px 18px;
  color: ${({ theme }) => theme.colors.buttonFont};
  background-color: ${({ theme }) => theme.colors.primary};
  font-feature-settings: "case" on;
  font-family: ${(props) => props.theme.typography.textsFont};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 183.333% */
  letter-spacing: -0.0408px;
  margin-top: 10px;
  align-self: end;
  p {
    width: 100%;
    overflow-wrap: anywhere;
    margin: 0;
  }
`;

export const StyledMessageAvatar = styled.div`
  cursor: pointer;
  display: flex;
  height: 44px;
  min-width: 44px;
  padding: 2px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.avatar};
  img {
    filter: ${({ theme }) =>
      theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
  }
`;
